import React from 'react';
import {theme} from '../../../styles/darkTheme';
import {Container, Text} from './styles';

interface Props {
  size?: number;
  children: React.ReactNode
}

const Badge: React.FC<Props> = ({size = 20, children}) => {
  return (
    <Container theme={theme} size={size}>
      <Text theme={theme} size={size}>
        {children}
      </Text>
    </Container>
  );
};

export default Badge;
